import type * as ents from '@attain-apps/entities'
export interface State {
  /**
   * Lookup of process {@link ents.core.relay.processes.Process.Id} to whether
   * the sidebar for that {@link ents.core.relay.processes.Process} is expanded
   *
   * @default {}
   */
  expandLookup: Partial<Record<ents.core.relay.processes.Process.Id, boolean>>
  /**
   * The {@link ents.core.relay.processes.Process.Id} of the process currently
   * marked for stopping (i.e. the stop confirmation dialog is open)
   *
   * @default undefined
   */
  stoppingProcessId?: ents.core.relay.processes.Process.Id
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    expandLookup: {},
    stoppingProcessId: undefined,
  }
}
